import T from 'i18n-react'
import {
  createSelectorWithPath,
  createSelectorWithEntity,
  labelSelectorFunc,
} from 'helpers/ComponentSelectorUtil'

const valuesSelectorFunc = state => (state.values && state.values[0]) ? state.values[0].value : ''
const hintSelectorFunc = state => (state.defaultValue) ? T.translate(state.defaultValue) : ''
const getValueSelector = (path, id) => createSelectorWithPath(`${path}.${id}`, valuesSelectorFunc)

export {
  getValueSelector
}

export default (path) => {
  const selectorWithPath = createSelectorWithPath(path)
  const valueSelector = selectorWithPath(valuesSelectorFunc)
  const hintSelector = selectorWithPath(hintSelectorFunc)
  const labelSelector = selectorWithPath(labelSelectorFunc)

  return {
    valueSelector,
    hintSelector,
    labelSelector,
  }
}
